/* ==========================================================================
   Custom product — gallery + buy box + custom-order inputs.

   A copy of updated-product.js (kept separate so the two sections can be
   changed independently) with the custom-order inputs added: text fields,
   photo uploads and an add-on line, all sent as line-item properties.

   This file is static: every Liquid-dependent value (variants, prices, section
   settings, routes) is rendered into a <script type="application/json"> block
   by the section and read here. That keeps the JS cacheable and lintable
   instead of being inlined into the page on every render.
   ========================================================================== */
(function () {
  var root = document.querySelector('[data-cp-buybox]');
  if (!root) return;

  var dataEl = root.querySelector('[data-fb-data]');
  if (!dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var FB_VARIANTS = DATA.variants || [];
  var SALE_TIERS = (DATA.saleTiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
  var CURRENCY_CODE = DATA.currency || 'USD';
  var MAX_QTY = 99;

  /* ------------------------------------------------------------------------
     Pricing

     The bulk sale tiers apply across ANY products in the cart, so they are a
     native Shopify automatic discount — this page only DISPLAYS them. The
     cart is sent a plain quantity and Shopify decides what to charge. The
     button total below is therefore an estimate for this item alone; anything
     already in the cart can push the order into a higher tier at checkout.
     ------------------------------------------------------------------------ */
  function tierFor(qty) {
    var hit = null;
    SALE_TIERS.forEach(function (t) { if (qty >= t.qty) hit = t; });
    return hit;
  }

  function linePricing(unitPrice, qty) {
    var gross = unitPrice * qty;
    // "Each extra item X% off" (acrylic stands: every stand after the first
    // is 75% off) instead of percentage tiers on the whole line.
    if (DATA.bundleMode === 'each_extra') {
      // Rounded once at the end, as the store's own deal block does
      // ($39.95 stand: 2 = $49.94, 3 = $59.93, 4 = $69.91).
      var total = Math.round(unitPrice + Math.max(0, qty - 1) * unitPrice * (100 - (Number(DATA.extraPercent) || 0)) / 100);
      return { gross: gross, saved: gross - total, total: total };
    }
    var tier = tierFor(qty);
    var saved = tier ? Math.round(gross * tier.percent / 100) : 0;
    return { gross: gross, saved: saved, total: gross - saved };
  }

  // shop.money_format is NOT market-aware — it always returns the shop's default
  // currency format regardless of which Shopify Markets currency the visitor is
  // actually in. Variant prices ARE already converted for the active market, so
  // we only need a market-aware currency code and let Intl do the formatting.
  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(navigator.language || 'en', { style: 'currency', currency: CURRENCY_CODE }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + CURRENCY_CODE;
    }
  }

  /* ------------------------------------------------------------------------
     Options

     Every product option gets a picker: an option named like "Size" gets the
     size cards, everything else (Color, Plug type…) gets pills, with a colour
     dot for a "Color" option. The selection is one value per option; the
     variant is whichever has exactly those values.

     A value that can't combine with the other current picks (no such
     variant, or it's sold out) is shown struck through but stays clickable:
     picking it jumps to the closest variant that has it, preferring one
     that's in stock.
     ------------------------------------------------------------------------ */
  // Older JSON (or a variant without an options array) falls back to option1–3.
  FB_VARIANTS.forEach(function (v) {
    if (!v.options) v.options = [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
  });

  var OPTIONS = (DATA.options && DATA.options.length) ? DATA.options : [{
    name: DATA.sizeHeading || 'Size',
    values: FB_VARIANTS.reduce(function (acc, v) { if (acc.indexOf(v.options[0]) === -1) acc.push(v.options[0]); return acc; }, [])
  }];

  var SIZE_RE = /size|größe|grosse|taille|taglia|tamaño|dydis/i;
  var COLOR_RE = /colou?r|farbe|couleur|colore|spalva/i;
  var SIZE_INDEX = -1;
  // A section can turn the size cards off (DATA.sizeCards === false), so a
  // "Size and Style" option with long values shows as buttons instead.
  OPTIONS.forEach(function (o, i) { if (DATA.sizeCards !== false && SIZE_INDEX === -1 && SIZE_RE.test(o.name)) SIZE_INDEX = i; });
  // A section can name the option to show as cards outright (gift card:
  // its "Value" option, $50 / $100…).
  if (typeof DATA.cardOption === 'number' && OPTIONS[DATA.cardOption]) SIZE_INDEX = DATA.cardOption;

  // "XS - 20” inch / 50 cm" → code "XS", detail "20″ / 50 cm". The doubled-up
  // `” inch` is tidied to a single ″ for display only.
  function splitSize(value) {
    var sep = value.indexOf(' - ');
    if (sep === -1) {
      // "Size and Style" values with no " - ": "XL + BLUE Neon light",
      // "M without Neon light" → code "XL" / "M", detail "Blue neon light" /
      // "Without neon light", so they fit the same cards as plain sizes.
      var m = /^(XXS|XS|S|M|L|XL|XXL|XXXL|\d?XL)\b\s*\+?\s*(.+)$/i.exec(String(value).trim());
      if (m) return { code: m[1].toUpperCase(), detail: tidyDetail(m[2]) };
      return { code: value, detail: '' };
    }
    return {
      code: value.slice(0, sep).trim(),
      detail: value.slice(sep + 3).replace(/\s*["”″]\s*inch(es)?/gi, '″').trim()
    };
  }
  // "BLUE Neon light" → "Blue neon light"; known acronyms (RGB, LED…) stay.
  function tidyDetail(text) {
    var keep = /^(RGB|LED|UV|USB|EU|US|UK|AU)$/;
    var words = String(text).trim().split(/\s+/).map(function (w) {
      return keep.test(w.toUpperCase()) && w === w.toUpperCase() ? w : w.toLowerCase();
    });
    var out = words.join(' ');
    return out.charAt(0).toUpperCase() + out.slice(1);
  }

  // "PLUG TYPE" → "Plug type". Names already in mixed case are left alone,
  // and so are short codes like "US" / "EU" unless `always` is set (colour
  // names, where "RED" should match "Green").
  function tidyCase(text, always) {
    text = String(text || '');
    if ((always || text.length > 3) && text === text.toUpperCase() && /[A-Z]/.test(text)) {
      return text.charAt(0) + text.slice(1).toLowerCase();
    }
    return text;
  }

  // Colour for a "Color" option value: the "Colour swatches" setting first
  // (one "Name: #hex" per line), then a few standard names, then anything
  // the browser itself understands as a colour. No match → a text pill.
  var CUSTOM_SWATCHES = {};
  String(DATA.colorSwatches || '').split('\n').forEach(function (line) {
    var sep = line.indexOf(':');
    if (sep === -1) return;
    var name = line.slice(0, sep).trim().toLowerCase();
    var colour = line.slice(sep + 1).trim();
    if (name && colour) CUSTOM_SWATCHES[name] = colour;
  });
  var SWATCHES = {
    'red': '#E5372E', 'green': '#22C55E', 'blue': '#2F7BF5', 'pink': '#F054A9', 'yellow': '#FACC15',
    'orange': '#F97316', 'purple': '#9333EA', 'violet': '#8B5CF6', 'ice blue': '#7DD3FC',
    'warm white': '#FFD9A0', 'cold white': '#EAF4FF', 'cool white': '#EAF4FF', 'white': '#FFFFFF',
    'black': '#1F1F1F', 'gold': '#D4A62A', 'silver': '#C0C4C8', 'rgb': 'conic-gradient(#f43f5e, #facc15, #22c55e, #3b82f6, #a855f7, #f43f5e)'
  };
  function swatchFor(value) {
    var key = String(value).trim().toLowerCase();
    if (CUSTOM_SWATCHES[key]) return CUSTOM_SWATCHES[key];
    if (SWATCHES[key]) return SWATCHES[key];
    if (window.CSS && CSS.supports && CSS.supports('color', key.replace(/\s+/g, ''))) return key.replace(/\s+/g, '');
    return '';
  }

  // The "Most popular" badge setting names a size by its code (M) — or the
  // whole option value, for sizes without a " - " — ignoring case.
  function isBadgeSize(code, value) {
    var wanted = String(DATA.sizeBadgeSize || '').trim().toLowerCase();
    if (!wanted || !DATA.sizeBadgeText) return false;
    return code.toLowerCase() === wanted || value.toLowerCase() === wanted;
  }

  function variantFor(sel) {
    return FB_VARIANTS.filter(function (v) {
      for (var i = 0; i < sel.length; i++) if (v.options[i] !== sel[i]) return false;
      return true;
    })[0] || null;
  }

  // Closest variant that has `value` for option `index`: in stock first, then
  // the one sharing the most of the other current picks.
  function closestVariant(index, value) {
    var best = null, bestScore = -1;
    FB_VARIANTS.forEach(function (v) {
      if (v.options[index] !== value) return;
      var score = v.available ? 100 : 0;
      for (var i = 0; i < state.sel.length; i++) if (i !== index && v.options[i] === state.sel[i]) score += 1;
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  function currentVariant() { return variantFor(state.sel); }

  var initialVariant = FB_VARIANTS.filter(function (v) { return String(v.id) === String(DATA.selectedVariantId); })[0] ||
    FB_VARIANTS.filter(function (v) { return v.available; })[0] || FB_VARIANTS[0];

  var state = {
    sel: initialVariant ? initialVariant.options.slice() : OPTIONS.map(function (o) { return o.values[0]; }),
    qty: 1
  };

  /* ------------------------------------------------------------------------
     Elements
     ------------------------------------------------------------------------ */
  var optionsWrap = root.querySelector('[data-fb-options]');
  var tierRows = root.querySelectorAll('[data-fb-tier]');
  var saleHint = root.querySelector('[data-fb-sale-hint]');
  var ladderFill = root.querySelector('[data-fb-ladder-fill]');
  var qtyInput = root.querySelector('[data-fb-qty-input]');
  var qtyMinus = root.querySelector('[data-fb-qty-minus]');
  var qtyPlus = root.querySelector('[data-fb-qty-plus]');
  var variantInput = root.querySelector('[data-fb-variant-id]');
  var priceEl = root.querySelector('[data-fb-price]');
  var compareEl = root.querySelector('[data-fb-compare]');
  var addBtn = root.querySelector('[data-fb-add-btn]');
  var addLabel = root.querySelector('[data-fb-add-label]');
  var addPrice = root.querySelector('[data-fb-add-price]');
  var errorEl = root.querySelector('[data-fb-error]');
  var stockEl = root.querySelector('[data-fb-stock]');
  var stockText = root.querySelector('[data-fb-stock-text]');
  var form = root.querySelector('.fb-form');

  /* ------------------------------------------------------------------------
     Option pickers
     ------------------------------------------------------------------------ */
  function choose(index, value) {
    var candidate = state.sel.slice();
    candidate[index] = value;
    if (variantFor(candidate)) {
      state.sel = candidate;
    } else {
      var near = closestVariant(index, value);
      if (!near) return;
      state.sel = near.options.slice();
    }
    renderOptions();
    sync();
    updateUrl();
    showVariantMedia(currentVariant());
  }

  // What picking `value` for option `index` would give, with the other
  // current picks kept: the exact variant, or null if that combo doesn't exist.
  function variantIfPicked(index, value) {
    var candidate = state.sel.slice();
    candidate[index] = value;
    return variantFor(candidate);
  }

  function buildSizeCard(index, value) {
    var exact = variantIfPicked(index, value);
    var shown = exact || closestVariant(index, value);
    var parts = splitSize(value);
    var active = state.sel[index] === value;
    var unavailable = !exact || !exact.available;
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'fb-size' + (active ? ' is-active' : '') + (unavailable ? ' is-soldout' : '');
    card.setAttribute('role', 'radio');
    card.setAttribute('aria-checked', active ? 'true' : 'false');
    card.setAttribute('aria-label', value + (unavailable ? ' — unavailable' : ''));
    card.innerHTML =
      '<span class="fb-size-code"></span>' +
      (parts.detail ? '<span class="fb-size-detail"></span>' : '') +
      '<span class="fb-size-price"></span>';
    card.querySelector('.fb-size-code').textContent = parts.code;
    if (parts.detail) {
      // Each " / "-separated measurement gets its own span, so on a phone
      // the CSS can stack 20″ over 50 cm and the card stays narrow.
      var detailEl = card.querySelector('.fb-size-detail');
      parts.detail.split(' / ').forEach(function (bit, j) {
        if (j > 0) {
          var sep = document.createElement('span');
          sep.className = 'fb-size-sep';
          sep.textContent = ' / ';
          detailEl.appendChild(sep);
        }
        var span = document.createElement('span');
        span.textContent = bit;
        detailEl.appendChild(span);
      });
    }
    card.querySelector('.fb-size-price').textContent =
      exact && !exact.available ? 'Sold out' : (shown ? formatMoney(shown.price) : '');
    // Gift card amounts: the card already says $50, so no price underneath.
    if (DATA.cardPrices === false && !(exact && !exact.available)) card.querySelector('.fb-size-price').remove();
    if (isBadgeSize(parts.code, value)) {
      var badge = document.createElement('span');
      badge.className = 'fb-size-badge';
      badge.textContent = DATA.sizeBadgeText;
      card.insertBefore(badge, card.firstChild);
    }
    card.addEventListener('click', function () { choose(index, value); });
    return card;
  }

  // A colour value with a known colour is a plain circle of that colour (the
  // name is in the label above and in the tooltip); otherwise a text pill.
  function buildSwatch(index, value, colour) {
    var exact = variantIfPicked(index, value);
    var active = state.sel[index] === value;
    var unavailable = !exact || !exact.available;
    var name = tidyCase(value, true);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fb-swatch' + (active ? ' is-active' : '') + (unavailable ? ' is-unavailable' : '');
    btn.setAttribute('role', 'radio');
    btn.setAttribute('aria-checked', active ? 'true' : 'false');
    btn.setAttribute('aria-label', name + (unavailable ? ' — unavailable' : ''));
    btn.title = name;
    var fill = document.createElement('span');
    fill.className = 'fb-swatch-fill';
    fill.setAttribute('aria-hidden', 'true');
    fill.style.background = colour;
    if (colour.indexOf('gradient') === -1) fill.style.setProperty('--fb-glow', colour);
    btn.appendChild(fill);
    btn.addEventListener('click', function () { choose(index, value); });
    return btn;
  }

  function buildPill(index, value, isColor) {
    var exact = variantIfPicked(index, value);
    var active = state.sel[index] === value;
    var unavailable = !exact || !exact.available;
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'fb-pill' + (active ? ' is-active' : '') + (unavailable ? ' is-unavailable' : '');
    pill.setAttribute('role', 'radio');
    pill.setAttribute('aria-checked', active ? 'true' : 'false');
    pill.setAttribute('aria-label', value + (unavailable ? ' — unavailable' : ''));
    if (isColor) {
      var colour = swatchFor(value);
      if (colour) {
        var dot = document.createElement('span');
        dot.className = 'fb-pill-swatch';
        dot.setAttribute('aria-hidden', 'true');
        dot.style.background = colour;
        if (colour.indexOf('gradient') === -1) dot.style.setProperty('--fb-glow', colour);
        pill.appendChild(dot);
      }
    }
    pill.appendChild(document.createTextNode(isColor ? tidyCase(value, true) : value));
    pill.addEventListener('click', function () { choose(index, value); });
    return pill;
  }

  function renderOptions() {
    if (!optionsWrap) return;
    optionsWrap.innerHTML = '';
    OPTIONS.forEach(function (option, index) {
      // Only Shopify's placeholder option ("Title: Default Title", on products
      // with no options) is hidden. A real option with a single value — e.g. a
      // one-off stock-sale piece in one size — still shows, already picked,
      // so the customer can see what they're getting.
      if (!option.values || !option.values.length) return;
      if (option.values.length === 1 && (option.values[0] === 'Default Title' || option.name === 'Title')) return;
      var isSize = index === SIZE_INDEX;
      var isColor = !isSize && COLOR_RE.test(option.name);
      var label = isSize && DATA.sizeHeading ? DATA.sizeHeading : tidyCase(option.name);

      var field = document.createElement('div');
      field.className = 'fb-field';
      field.setAttribute('data-fb-option', index);

      var head = document.createElement('div');
      head.className = 'fb-field-label';
      var name = document.createElement('span');
      name.textContent = label;
      var picked = document.createElement('span');
      picked.className = 'fb-selected';
      picked.textContent = isColor ? tidyCase(state.sel[index], true) : (state.sel[index] || '');
      head.appendChild(name);
      head.appendChild(picked);
      field.appendChild(head);

      var group = document.createElement('div');
      group.className = isSize ? 'fb-size-grid' : isColor ? 'fb-pill-row fb-swatch-row' : 'fb-pill-row';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', label);
      option.values.forEach(function (value) {
        var colour = isColor ? swatchFor(value) : '';
        group.appendChild(isSize ? buildSizeCard(index, value) : colour ? buildSwatch(index, value, colour) : buildPill(index, value, isColor));
      });
      if (isSize && group.querySelector('.fb-size-badge')) group.classList.add('has-badge');
      // More than five sizes don't fit one phone row: wrap them in fours.
      if (isSize && option.values.length > 5) group.classList.add('is-many');
      field.appendChild(group);

      if (isSize && DATA.sizeNote) {
        var note = document.createElement('p');
        note.className = 'fb-size-note';
        note.textContent = DATA.sizeNote;
        field.appendChild(note);
      }
      optionsWrap.appendChild(field);
    });
  }

  // Keeps ?variant= in the address bar in step with the picked options, so a
  // shared or refreshed link opens on the same variant. Product pages only.
  function updateUrl() {
    if (!DATA.updateUrl || !DATA.hasRealVariants || !window.history || !history.replaceState) return;
    var v = currentVariant();
    if (!v) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url.toString());
    } catch (e) {}
  }

  // A variant with its own image (e.g. a neon colour) brings that photo up
  // in the gallery. Declared as a function so it can run before the gallery
  // code further down has set up; it only acts once that has.
  function showVariantMedia(variant, instant) {
    if (!variant || !variant.mediaId || typeof galleryWrap === 'undefined' || !galleryWrap) return;
    var slide = galleryWrap.querySelector('[data-fb-media-id="' + variant.mediaId + '"]');
    if (!slide) return;
    var index = parseInt(slide.getAttribute('data-fb-slide'), 10);
    if (isNaN(index)) return;
    galleryWrap.scrollTo({ left: galleryWrap.clientWidth * index, behavior: instant ? 'auto' : 'smooth' });
    if (typeof markActive === 'function') markActive(index);
  }

  /* ------------------------------------------------------------------------
     Quantity

     Capped at what's actually in stock when Shopify tracks the variant's
     inventory and doesn't allow overselling (e.g. a stock-sale piece with 1
     left). Made-to-order variants aren't tracked, so they go up to 99.
     ------------------------------------------------------------------------ */
  function maxQty(variant) {
    variant = variant || currentVariant();
    if (variant && variant.tracked) {
      var left = parseInt(variant.inventory, 10) || 0;
      return Math.max(1, Math.min(MAX_QTY, left));
    }
    return MAX_QTY;
  }

  function setQty(next) {
    next = parseInt(next, 10);
    if (isNaN(next) || next < 1) next = 1;
    var max = maxQty();
    if (next > max) next = max;
    state.qty = next;
    sync();
  }

  if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(state.qty - 1); });
  if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(state.qty + 1); });
  if (qtyInput) {
    // Live while typing, but only clamp/rewrite the field on commit, so
    // clearing it to type "12" doesn't snap straight back to 1.
    qtyInput.addEventListener('input', function () {
      var n = parseInt(qtyInput.value, 10);
      if (!isNaN(n) && n >= 1) { state.qty = Math.min(n, maxQty()); sync(true); }
    });
    qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
  }

  // Tapping a ladder step is a shortcut to that step's quantity.
  tierRows.forEach(function (row) {
    row.addEventListener('click', function () {
      setQty(parseInt(row.getAttribute('data-fb-tier'), 10));
    });
  });

  // "Add 1 more item to get 30% off" — points at the next tier up from the
  // chosen quantity, or confirms the top tier once it's reached.
  function renderSaleHint() {
    if (!saleHint || SALE_TIERS.length === 0) return;
    var next = SALE_TIERS.filter(function (t) { return t.qty > state.qty; })[0];
    var text;
    if (next) {
      var n = next.qty - state.qty;
      text = (DATA.saleHintMore || '')
        .replace('[n]', n)
        .replace('[items]', n === 1 ? 'item' : 'items')
        .replace('[percent]', next.percent);
    } else {
      text = (DATA.saleHintBest || '').replace('[percent]', SALE_TIERS[SALE_TIERS.length - 1].percent);
    }
    saleHint.textContent = text;
    saleHint.hidden = !text;
    saleHint.classList.toggle('is-best', !next);
  }

  /* ------------------------------------------------------------------------
     Stock line

     Real numbers only: a variant whose inventory Shopify tracks shows "Only
     3 left" at or below the threshold, the "plenty" text above it. A variant
     that isn't tracked (or keeps selling when out) shows the "not tracked"
     text instead, e.g. made to order. Sold out is left to the button.
     ------------------------------------------------------------------------ */
  function renderStock(variant) {
    if (!stockEl || !stockText) return;
    var cfg = DATA.stock || {};
    var text = '', level = '';
    if (variant && variant.available) {
      if (variant.tracked) {
        var left = Math.max(0, parseInt(variant.inventory, 10) || 0);
        if (left > 0 && left <= (parseInt(cfg.threshold, 10) || 10)) {
          text = (cfg.low || '').replace('[count]', left);
          level = 'low';
        } else {
          text = cfg.ok || '';
          level = 'ok';
        }
      } else {
        text = cfg.untracked || '';
        level = 'made';
      }
    }
    stockText.textContent = text;
    stockEl.hidden = !text;
    stockEl.setAttribute('data-level', level);
  }

  /* ------------------------------------------------------------------------
     Sync — one place that writes every price, input and state class
     ------------------------------------------------------------------------ */
  function sync(keepQtyField) {
    var variant = currentVariant();
    if (!variant) {
      renderStock(null);
      if (errorEl) errorEl.classList.add('is-visible');
      if (addBtn) addBtn.disabled = true;
      return;
    }
    if (errorEl) errorEl.classList.remove('is-visible');

    // Switching to a variant with less stock pulls the quantity down to fit.
    var max = maxQty(variant);
    if (state.qty > max) { state.qty = max; keepQtyField = false; }

    if (variantInput) variantInput.value = variant.id;
    if (qtyInput) {
      qtyInput.max = max;
      if (!keepQtyField) qtyInput.value = state.qty;
    }
    if (qtyMinus) qtyMinus.disabled = state.qty <= 1;
    if (qtyPlus) qtyPlus.disabled = state.qty >= max;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compareAtPrice > variant.price) {
        compareEl.textContent = formatMoney(variant.compareAtPrice);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // The highest step the quantity reaches is the selected one, so typing 7
    // into the stepper selects the 4+ step. Every step at or below it counts
    // as reached, and the ladder's track fills up to it. The same hooks drive
    // the Tiles and List layouts, which simply ignore is-reached.
    var activeQty = 0;
    tierRows.forEach(function (row) {
      var qty = parseInt(row.getAttribute('data-fb-tier'), 10);
      if (qty <= state.qty && qty > activeQty) activeQty = qty;
    });
    tierRows.forEach(function (row) {
      var qty = parseInt(row.getAttribute('data-fb-tier'), 10);
      var p = linePricing(variant.price, qty);
      var totalSpan = row.querySelector('[data-fb-tier-total]');
      var wasSpan = row.querySelector('[data-fb-tier-was]');
      var eachSpan = row.querySelector('[data-fb-tier-each]');
      var saveSpan = row.querySelector('[data-fb-tier-save]');
      if (saveSpan && qty > 1 && p.gross) {
        // Exact share for the each-extra deal (2 stands = 37.5% → 38%, as the
        // store's own deal block shows), from the prices otherwise.
        var pct = DATA.bundleMode === 'each_extra'
          ? (qty - 1) * (Number(DATA.extraPercent) || 0) / qty
          : p.saved / p.gross * 100;
        saveSpan.textContent = (DATA.dealSaveLabel || 'Save [percent]%').replace('[percent]', Math.round(pct));
      }
      if (totalSpan) totalSpan.textContent = formatMoney(p.total);
      if (wasSpan) wasSpan.textContent = formatMoney(p.gross);
      if (eachSpan) eachSpan.textContent = formatMoney(Math.round(p.total / qty));
      var on = qty === activeQty;
      row.classList.toggle('is-active', on);
      row.classList.toggle('is-reached', qty <= activeQty);
      row.setAttribute('aria-pressed', on ? 'true' : 'false');
      // A bundle bigger than what's in stock can't be picked.
      row.disabled = qty > max;
    });
    if (ladderFill) {
      var ladderSteps = Array.prototype.slice.call(ladderFill.closest('.fb-ladder').querySelectorAll('[data-fb-tier]'));
      var stepIndex = 0;
      ladderSteps.forEach(function (step, i) { if (step.classList.contains('is-active')) stepIndex = i; });
      ladderFill.style.width = ladderSteps.length > 1 ? (stepIndex / (ladderSteps.length - 1) * 100) + '%' : '0%';
    }
    renderSaleHint();

    var pricing = linePricing(variant.price, state.qty);
    if (addPrice) addPrice.textContent = formatMoney(pricing.total + (typeof addonPrice === 'function' ? addonPrice() : 0) + feePrice());
    renderStock(variant);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    root.dispatchEvent(new Event('change', { bubbles: true }));
  }

  renderOptions();
  sync();

  // Cross-section quantity shortcut: other sections (e.g. a bottom banner's
  // "Buy 2, save" button) dispatch this on `document` rather than reaching into
  // our DOM, since each section is an independent partial.
  document.addEventListener('fb:select-qty', function (e) {
    var qty = e.detail && e.detail.qty;
    if (typeof qty === 'number' && qty >= 1) setQty(qty);
  });

  /* ------------------------------------------------------------------------
     Wiggle phrase

     The highlighted phrase in the bundle footer ("Mix & match any
     products") wiggles when it scrolls fully into view, then again every
     "Wiggle every" seconds while it stays on screen (0 = only on arrival).
     A short cooldown stops it twitching when scrolled up and down quickly.
     Skipped entirely for visitors who ask for reduced motion.
     ------------------------------------------------------------------------ */
  var wiggle = root.querySelector('[data-fb-wiggle]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (wiggle && !reduceMotion && 'IntersectionObserver' in window) {
    var WIGGLE_COOLDOWN = 2000;
    var wiggleEvery = Math.max(0, Number(DATA.wiggleEvery) || 0) * 1000;
    var lastWiggle = 0;
    var wiggleTimer = null;
    var startDelay = null;
    var wiggleInView = false;

    var playWiggle = function () {
      var now = Date.now();
      if (now - lastWiggle < WIGGLE_COOLDOWN) return;
      lastWiggle = now;
      wiggle.classList.remove('is-wiggling');
      void wiggle.offsetWidth; // restart the animation if it ran before
      wiggle.classList.add('is-wiggling');
    };
    var stopRepeat = function () {
      clearTimeout(startDelay);
      clearInterval(wiggleTimer);
      startDelay = wiggleTimer = null;
    };
    var startRepeat = function () {
      stopRepeat();
      // Short delay so the eye has landed on it before it moves.
      startDelay = setTimeout(playWiggle, 250);
      if (wiggleEvery > 0) wiggleTimer = setInterval(playWiggle, wiggleEvery);
    };

    wiggle.addEventListener('animationend', function () { wiggle.classList.remove('is-wiggling'); });
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        wiggleInView = entry.isIntersecting;
        if (wiggleInView) startRepeat(); else stopRepeat();
      });
    }, { threshold: 1 }).observe(wiggle);

    // No point animating in a background tab; pick up again on return.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopRepeat();
      else if (wiggleInView) startRepeat();
    });
  }

  /* ------------------------------------------------------------------------
     Info tabs

     Standard WAI-ARIA tabs: click or arrow keys switch, Home/End jump. The
     theme editor's block-select event opens the tab being edited.
     ------------------------------------------------------------------------ */
  var tabsWrap = root.querySelector('[data-fb-tabs]');
  if (tabsWrap) {
    var tabs = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-fb-tab]'));
    var panels = Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-fb-tab-panel]'));
    var tabList = tabsWrap.querySelector('[role="tablist"]');

    var selectTab = function (index, focus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].hidden = !on;
      });
      if (focus && tabs[index]) tabs[index].focus();
      // On phones the tab strip scrolls sideways — bring the active tab into
      // view by scrolling the strip only, never the page.
      var t = tabs[index];
      if (tabList && t && tabList.scrollWidth > tabList.clientWidth) {
        tabList.scrollTo({ left: t.offsetLeft - (tabList.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      }
    };

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { selectTab(i, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) { e.preventDefault(); selectTab(next, true); }
      });
    });

    document.addEventListener('shopify:block:select', function (e) {
      var i = tabs.indexOf(e.target);
      if (i !== -1) selectTab(i, false);
    });
  }

  /* ------------------------------------------------------------------------
     Custom-order inputs

     Text fields are ordinary form fields named properties[...], so the form
     carries them. Photos are held here (so customers can pick several at
     once, drop them in, and remove one) and appended to the form data as
     properties[Photo 1], [Photo 2]… on submit; Shopify uploads the files.
     Choice fields (plug type…) are radio cards or a dropdown in the form.
     The add-on is a tick box that adds a second product after the main one.
     ------------------------------------------------------------------------ */
  var CP = DATA.custom || {};
  var textFields = Array.prototype.slice.call(root.querySelectorAll('[data-cp-text]'));
  var photoBlocks = Array.prototype.slice.call(root.querySelectorAll('[data-cp-photos]'));
  var choiceFields = Array.prototype.slice.call(root.querySelectorAll('[data-cp-choice]'));
  var addon = root.querySelector('[data-cp-addon]');
  var addonCheck = addon && addon.querySelector('[data-cp-addon-check]');
  var addonMessageWrap = addon && addon.querySelector('[data-cp-addon-message]');
  var addonText = addon && addon.querySelector('[data-cp-addon-text]');
  var addonCount = addon && addon.querySelector('[data-cp-addon-count]');

  function showFieldError(field, message) {
    var err = field.querySelector('[data-cp-error]');
    field.classList.toggle('has-error', !!message);
    if (err) { err.textContent = message || ''; err.hidden = !message; }
  }

  // Character counters + clear the error as soon as the customer types.
  textFields.forEach(function (field) {
    var control = field.querySelector('[data-cp-control]');
    var count = field.querySelector('[data-cp-count]');
    if (!control) return;
    var update = function () {
      if (count) count.textContent = control.value.length + '/' + control.maxLength;
      if (control.value.trim()) showFieldError(field, '');
    };
    control.addEventListener('input', update);
    // Enter in a one-line field would submit the form (= add to cart).
    if (control.tagName === 'INPUT') {
      control.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    }
    update();
  });

  /* Choice fields (e.g. plug type): radio cards or a dropdown, posted as
     properties[...] with the form. "Show when" ties a field to option
     values — a plug type only matters "With LED Lights" — so it's hidden and
     its inputs disabled (left out of the cart) for any other variant. */
  function choiceControls(field) {
    return Array.prototype.slice.call(field.querySelectorAll('[data-cp-choice-control]'));
  }
  function choiceValue(field) {
    var picked = '';
    choiceControls(field).forEach(function (c) {
      if (c.tagName === 'SELECT') picked = c.value;
      else if (c.checked) picked = c.value;
    });
    return picked;
  }
  function choiceVisible(field) { return !field.hidden; }
  function renderChoice(field) {
    var value = choiceValue(field);
    var label = field.querySelector('[data-cp-choice-picked]');
    if (label) label.textContent = value;
    field.querySelectorAll('.cp-choice-opt').forEach(function (opt) {
      var input = opt.querySelector('input');
      opt.classList.toggle('is-active', !!(input && input.checked));
    });
    if (value) showFieldError(field, '');
  }
  // Show when / hide when match any picked option value CONTAINING the text,
  // ignoring case: "Neon light" matches "XL + BLUE Neon light"; hide when
  // "without" then drops "XL without Neon light". "With LED Lights" doesn't
  // match "Without LED Lights", so exact values keep working too.
  function choiceTerms(field, attr) {
    return (field.getAttribute(attr) || '').split(',')
      .map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
  }
  function syncChoiceVisibility() {
    var variant = currentVariant();
    var picked = (variant ? variant.options : state.sel).map(function (o) { return String(o).trim().toLowerCase(); });
    var hit = function (term) { return picked.some(function (p) { return p.indexOf(term) !== -1; }); };
    choiceFields.forEach(function (field) {
      var when = choiceTerms(field, 'data-show-when');
      var unless = choiceTerms(field, 'data-hide-when');
      var show = (!when.length || when.some(hit)) && !unless.some(hit);
      field.hidden = !show;
      choiceControls(field).forEach(function (c) { c.disabled = !show; });
      if (!show) showFieldError(field, '');
    });
  }
  choiceFields.forEach(function (field) {
    choiceControls(field).forEach(function (c) {
      c.addEventListener('change', function () { renderChoice(field); });
    });
    renderChoice(field);
  });
  // The buy box fires "change" on itself after every option pick (see sync).
  root.addEventListener('change', function (e) { if (e.target === root) syncChoiceVisibility(); });
  syncChoiceVisibility();

  // Phone photos are often 4–12 MB, which makes the add to cart crawl. Each
  // photo is shrunk in the browser as soon as it's picked (longest side down
  // to the block's max size, saved as a high-quality JPEG), so the upload is
  // usually around 1 MB per photo. What's uploaded is what Shopify keeps, so
  // the max size is the size you'll see on the order. Small photos, and HEIC
  // files (most browsers can't open them), are sent as they are; if anything
  // goes wrong the original is sent instead.
  function shrinkPhoto(file, maxEdge) {
    var keep = function () { return Promise.resolve(file); };
    if (!maxEdge || /heic|heif|gif|svg/i.test(file.type) || /\.(heic|heif)$/i.test(file.name)) return keep();
    if (file.size < 500 * 1024) return keep();

    var load = window.createImageBitmap
      ? createImageBitmap(file, { imageOrientation: 'from-image' })
      : new Promise(function (resolve, reject) {
          var img = new Image();
          img.onload = function () { resolve(img); };
          img.onerror = reject;
          img.src = URL.createObjectURL(file);
        });

    // Never let a photo that won't load hold up Add to cart: after 15 s the
    // original is used instead.
    var timeout = new Promise(function (resolve) { setTimeout(function () { resolve(null); }, 15000); });

    return Promise.race([load, timeout]).then(function (pic) {
      if (!pic) return file;
      var w = pic.width, h = pic.height;
      var scale = Math.min(1, maxEdge / Math.max(w, h));
      if (scale === 1 && file.size < 1.5 * 1024 * 1024) return file;
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(w * scale);
      canvas.height = Math.round(h * scale);
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff'; // a transparent PNG would otherwise turn black as JPEG
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(pic, 0, 0, canvas.width, canvas.height);
      if (pic.close) pic.close();
      return new Promise(function (resolve) {
        canvas.toBlob(function (blob) {
          if (!blob || blob.size >= file.size) { resolve(file); return; }
          var name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
          try {
            resolve(new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified }));
          } catch (e) {
            blob.name = name; // very old Safari has no File constructor
            resolve(blob);
          }
        }, 'image/jpeg', 0.88);
      });
    }).catch(keep);
  }

  // Photo uploader: several files at once, drag & drop, previews, remove.
  // Each pick is an item { original, file, ready }: `file` becomes the shrunk
  // copy once `ready` settles; previews always use the original.
  photoBlocks.forEach(function (block) {
    var grid = block.querySelector('[data-cp-photo-grid]');
    var addTile = block.querySelector('[data-cp-photo-add]');
    var input = block.querySelector('[data-cp-photo-file]');
    var counter = block.querySelector('[data-cp-photo-count]');
    var max = Math.max(1, parseInt(block.getAttribute('data-max'), 10) || 4);
    var maxBytes = (parseFloat(block.getAttribute('data-max-mb')) || 20) * 1024 * 1024;
    var maxEdge = block.getAttribute('data-shrink') === 'false' ? 0 : (parseInt(block.getAttribute('data-max-edge'), 10) || 3000);
    block._cpItems = [];

    var isImage = function (file) {
      return /^image\//.test(file.type) || /\.(heic|heif)$/i.test(file.name);
    };

    var render = function () {
      Array.prototype.slice.call(grid.querySelectorAll('.cp-photo')).forEach(function (tile) {
        var img = tile.querySelector('img');
        if (img && img.src) URL.revokeObjectURL(img.src);
        tile.remove();
      });
      block._cpItems.forEach(function (item, i) {
        var file = item.original;
        var tile = document.createElement('div');
        tile.className = 'cp-photo';
        // Browsers other than Safari can't draw HEIC, so those show the
        // file name instead of a thumbnail (the file still uploads fine).
        if (/heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name)) {
          tile.classList.add('is-file');
          var name = document.createElement('span');
          name.className = 'cp-photo-name';
          name.textContent = file.name;
          tile.appendChild(name);
        } else {
          var img = document.createElement('img');
          img.alt = file.name;
          img.src = URL.createObjectURL(file);
          tile.appendChild(img);
        }
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cp-photo-remove';
        remove.setAttribute('aria-label', 'Remove ' + file.name);
        remove.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        remove.addEventListener('click', function () {
          block._cpItems.splice(i, 1);
          render();
        });
        tile.appendChild(remove);
        grid.insertBefore(tile, addTile);
      });
      addTile.hidden = block._cpItems.length >= max;
      if (counter) counter.textContent = block._cpItems.length + '/' + max;
    };

    var addFiles = function (list) {
      var skipped = [];
      Array.prototype.slice.call(list || []).forEach(function (file) {
        if (!isImage(file)) { skipped.push(file.name + ' isn\'t a photo'); return; }
        if (file.size > maxBytes) { skipped.push(file.name + ' is over ' + Math.round(maxBytes / 1048576) + ' MB'); return; }
        if (block._cpItems.length >= max) { skipped.push('only ' + max + ' photos fit'); return; }
        var item = { original: file, file: file };
        item.ready = shrinkPhoto(file, maxEdge).then(function (small) { item.file = small; });
        block._cpItems.push(item);
      });
      render();
      showFieldError(block, skipped.length ? 'Not added: ' + skipped.join(', ') + '.' : '');
    };

    input.addEventListener('change', function () {
      addFiles(input.files);
      input.value = ''; // so the same file can be picked again after removing it
    });
    ['dragenter', 'dragover'].forEach(function (type) {
      block.addEventListener(type, function (e) { e.preventDefault(); block.classList.add('is-dragging'); });
    });
    ['dragleave', 'drop'].forEach(function (type) {
      block.addEventListener(type, function (e) {
        e.preventDefault();
        if (type === 'dragleave' && block.contains(e.relatedTarget)) return;
        block.classList.remove('is-dragging');
      });
    });
    block.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });
    render();
  });

  // Add-on: the tick box shows the message box and adds its price to the
  // button total.
  // Declared (hoisted) so sync() can call it before the fee code below runs.
  function feePrice() {
    if (typeof feeEl === 'undefined' || !feeActive()) return 0;
    return (parseInt(feeEl.getAttribute('data-price'), 10) || 0) * feeQty();
  }
  function extrasNames() {
    var names = [];
    if (addonCheck && addonCheck.checked) names.push((addon.querySelector('.cp-addon-title') || { textContent: 'add-on' }).textContent.trim().toLowerCase());
    if (typeof feeEl !== 'undefined' && feeActive()) names.push((feeEl.getAttribute('data-title') || 'personalisation').toLowerCase());
    return names.join(', ');
  }
  function addonPrice() {
    return addonCheck && addonCheck.checked ? (parseInt(addon.getAttribute('data-price'), 10) || 0) : 0;
  }
  if (addonCheck) {
    addonCheck.addEventListener('change', function () {
      addon.classList.toggle('is-checked', addonCheck.checked);
      if (addonMessageWrap) addonMessageWrap.hidden = !addonCheck.checked;
      sync();
    });
  }
  if (addonText && addonCount) {
    addonText.addEventListener('input', function () {
      addonCount.textContent = addonText.value.length + '/' + addonText.maxLength;
    });
  }

  /* Personalisation fee: a separate product (e.g. a $5 "Personalisation"
     item) added to the cart automatically whenever the customer fills in a
     text field marked "Filling this in adds the fee" — once per item when
     "per item" is on. The line under the fields and the Add to cart price
     show it as soon as they type. */
  var feeEl = root.querySelector('[data-cp-fee]');
  var feeTriggers = textFields.filter(function (f) { return f.getAttribute('data-cp-fee-trigger') === 'true'; });
  function feeActive() {
    if (!feeEl || !feeEl.getAttribute('data-variant-id')) return false;
    return feeTriggers.some(function (f) {
      var c = f.querySelector('[data-cp-control]');
      return c && c.value.trim();
    });
  }
  // The link between an item and its fee is the design + what was typed:
  // the same product with the same custom colour/text always gets the same
  // reference, so adding it again (any quantity, any time) shares one fee,
  // while another design or another colour gets a fee of its own.
  function feeRef() {
    var title = root.querySelector('.fb-title');
    var key = (title ? title.textContent.trim().toLowerCase() : '') + '|' + feeTriggers.map(function (f) {
      var c = f.querySelector('[data-cp-control]');
      return c ? c.value.trim().toLowerCase().replace(/\s+/g, ' ') : '';
    }).join('|');
    var h = 5381;
    for (var i = 0; i < key.length; i++) h = ((h * 33) ^ key.charCodeAt(i)) >>> 0;
    return 'f' + h.toString(36);
  }
  function feeQty() { return feeEl && feeEl.getAttribute('data-per-item') === 'true' ? state.qty : 1; }
  function renderFee() {
    if (!feeEl) return;
    feeEl.hidden = !feeActive();
  }
  feeTriggers.forEach(function (f) {
    var c = f.querySelector('[data-cp-control]');
    if (c) c.addEventListener('input', function () { renderFee(); sync(true); });
  });
  renderFee();

  // Required fields are checked here (the browser's own check can't be used:
  // the form is submitted by script). The first problem is scrolled to.
  function validateInputs() {
    var first = null;
    textFields.forEach(function (field) {
      var control = field.querySelector('[data-cp-control]');
      var missing = field.getAttribute('data-cp-required') === 'true' && control && !control.value.trim();
      showFieldError(field, missing ? (CP.requiredError || 'Please fill this in.') : '');
      if (missing && !first) first = field;
    });
    choiceFields.forEach(function (field) {
      var missing = choiceVisible(field) && field.getAttribute('data-cp-required') === 'true' && !choiceValue(field);
      showFieldError(field, missing ? (CP.choiceRequiredError || 'Please choose one.') : '');
      if (missing && !first) first = field;
    });
    photoBlocks.forEach(function (block) {
      var missing = block.getAttribute('data-cp-required') === 'true' && !block._cpItems.length;
      if (missing) showFieldError(block, CP.photoRequiredError || 'Please add at least one photo.');
      if (missing && !first) first = block;
    });
    if (first) {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var focusable = first.querySelector('[data-cp-control], [data-cp-choice-control], [data-cp-photo-file]');
      if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 350);
    }
    return !first;
  }

  // Everything the form carries, minus empty answers, plus the photos.
  function buildCartData(variantId) {
    var fd = new FormData(form);
    var empty = [];
    fd.forEach(function (value, key) {
      if (key.indexOf('properties[') === 0 && typeof value === 'string' && !value.trim()) empty.push(key);
    });
    empty.forEach(function (key) { fd.delete(key); });
    fd.set('id', variantId);
    fd.set('quantity', state.qty);
    // Personalisation fee: hidden link between this line and its fee line,
    // so pv-fee-lock.js can keep the fee in step with it in the cart.
    if (feeActive()) {
      fd.set('properties[_fee_ref]', feeRef());
      fd.set('properties[_fee]', feeEl.getAttribute('data-variant-id'));
      // Per item: the fee follows this line's quantity. Otherwise one fee
      // covers the whole line (same design, any quantity).
      if (feeEl.getAttribute('data-per-item') === 'true') fd.set('properties[_fee_each]', '1');
    }
    photoBlocks.forEach(function (block) {
      var prefix = block.getAttribute('data-prefix') || 'Photo';
      block._cpItems.forEach(function (item, i) {
        fd.append('properties[' + prefix + ' ' + (i + 1) + ']', item.file, item.file.name || item.original.name);
      });
    });
    return fd;
  }

  function hasPhotos() {
    return photoBlocks.some(function (block) { return block._cpItems.length > 0; });
  }

  // Resolves once every picked photo has finished shrinking (usually long
  // before the customer reaches Add to cart).
  function photosReady() {
    var waits = [];
    photoBlocks.forEach(function (block) {
      block._cpItems.forEach(function (item) { waits.push(item.ready); });
    });
    return Promise.all(waits);
  }

  /* ------------------------------------------------------------------------
     Ajax add to cart (real variant ids only — demo mode just shows the UI)

     Sent as multipart FormData, not JSON, so text answers and photo files go
     with it as line-item properties. Then the add-on (if ticked) is added as
     its own line. If only the add-on fails, the main item stays in the cart
     and the customer is told.
     ------------------------------------------------------------------------ */
  var parseCartResponse = function (r) {
    return r.json().catch(function () { return {}; }).then(function (d) {
      if (!r.ok || d.status) throw d;
      return d;
    });
  };

  if (form && DATA.hasRealVariants && window.fetch) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || !variantInput.value || addBtn.disabled) return;
      if (errorEl) errorEl.classList.remove('is-visible');
      if (!validateInputs()) return;

      var originalText = addLabel.textContent;
      // A spinner replaces the button text while the item (and any photos)
      // upload; screen readers get the busy state instead.
      var setLoading = function (on) {
        addBtn.classList.toggle('is-loading', on);
        if (on) addBtn.setAttribute('aria-busy', 'true'); else addBtn.removeAttribute('aria-busy');
      };
      addBtn.disabled = true;
      setLoading(true);

      var variantId = variantInput.value;
      photosReady()
        .then(function () {
          return fetch(DATA.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: buildCartData(variantId)
          });
        })
        .then(parseCartResponse)
        .then(function () {
          var extras = [];
          if (addonCheck && addonCheck.checked) {
            var item = { id: addon.getAttribute('data-variant-id'), quantity: 1 };
            var message = addonText ? addonText.value.trim() : '';
            if (message) {
              item.properties = {};
              item.properties[addon.getAttribute('data-message-property') || 'Message'] = message;
            }
            extras.push(item);
          }
          if (feeActive()) {
            // Tagged with what it's for, so the two lines match up on the order.
            var title = root.querySelector('.fb-title');
            var v = currentVariant();
            var forText = (title ? title.textContent.trim() : '') + (v && v.title && v.title !== 'Default Title' ? ' — ' + v.title : '');
            extras.push({ id: feeEl.getAttribute('data-variant-id'), quantity: feeQty(), properties: { 'For': forText, '_fee_ref': feeRef(), '_fee_line': '1' } });
          }
          if (!extras.length) return null;
          return fetch(DATA.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: extras })
          })
            .then(parseCartResponse)
            .catch(function () {
              return { addonFailed: true };
            });
        })
        .then(function (addonResult) {
          setLoading(false);
          addLabel.textContent = 'Added ✓';
          // Open before refreshing. The theme's refresh() is async — it awaits a
          // fetch of the cart sections — so firing it first and opening straight
          // after races it: on a slow connection the drawer mounts against the
          // old (often empty) contents.
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          if (addonResult && addonResult.addonFailed && errorEl) {
            errorEl.textContent = 'Your item was added, but its extras (' + extrasNames() + ') couldn’t be. Please try adding them again.';
            errorEl.classList.add('is-visible');
          }
          setTimeout(function () { addLabel.textContent = originalText; addBtn.disabled = false; }, 1600);
        })
        .catch(function (err) {
          setLoading(false);
          addLabel.textContent = originalText;
          addBtn.disabled = false;
          if (errorEl) { errorEl.textContent = (err && (err.description || err.message)) || 'Could not add to cart.'; errorEl.classList.add('is-visible'); }
        });
    });
  }

  /* ------------------------------------------------------------------------
     "All reviews": the rating under the price opens Loox's own reviews popup
     (LOOX.openHCFloater, from the Loox app embed). If loox.js isn't on the
     page, the same Loox review widget opens in a lightbox of our own.
     ------------------------------------------------------------------------ */
  var reviewsBtn = root.querySelector('[data-fb-reviews-open]');
  var reviewsBox = null;
  function closeAllReviews() {
    if (!reviewsBox) return;
    reviewsBox.remove();
    reviewsBox = null;
    document.documentElement.classList.remove('fb-reviews-locked');
    if (reviewsBtn) reviewsBtn.focus();
  }
  function openAllReviews() {
    if (window.LOOX && typeof window.LOOX.openHCFloater === 'function') {
      window.LOOX.openHCFloater();
      return;
    }
    var id = reviewsBtn.getAttribute('data-loox-id');
    if (!id) return;
    closeAllReviews();
    reviewsBox = document.createElement('div');
    reviewsBox.className = 'fb-reviews-lightbox';
    reviewsBox.setAttribute('role', 'dialog');
    reviewsBox.setAttribute('aria-modal', 'true');
    reviewsBox.setAttribute('aria-label', 'Customer reviews');
    var frame = document.createElement('iframe');
    frame.className = 'fb-reviews-lightbox-frame';
    frame.title = 'Customer reviews';
    frame.src = 'https://loox.io/widget/' + encodeURIComponent(id) + '/reviews?h=' + Date.now();
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'fb-reviews-lightbox-close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';
    close.addEventListener('click', closeAllReviews);
    reviewsBox.addEventListener('click', function (e) { if (e.target === reviewsBox) closeAllReviews(); });
    reviewsBox.appendChild(frame);
    reviewsBox.appendChild(close);
    document.body.appendChild(reviewsBox);
    document.documentElement.classList.add('fb-reviews-locked');
    close.focus();
  }
  if (reviewsBtn) {
    reviewsBtn.addEventListener('click', function (e) { e.preventDefault(); openAllReviews(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllReviews(); });
  }

  /* ------------------------------------------------------------------------
     Store-wide Loox rating

     Loox ships no aggregate widget — its .loox-rating element is per-product
     via data-id, and the carousel renders as a cross-origin iframe we can't
     read. But its public reviews.json returns a `bottomline` of the whole
     store's average and review total, so we read that and keep our own markup.
     The server-rendered values stay as the fallback if the fetch fails.
     ------------------------------------------------------------------------ */
  var ratingRow = root.querySelector('[data-fb-loox]');
  if (ratingRow && window.fetch) {
    var looxId = ratingRow.getAttribute('data-fb-loox');
    var ratingValueEl = ratingRow.querySelector('[data-fb-rating-value]');
    var ratingCountEl = ratingRow.querySelector('[data-fb-rating-count]');
    var looxCacheKey = 'fbLooxBottomline:' + looxId;

    var applyBottomline = function (b) {
      if (!b) return;
      if (ratingValueEl && typeof b.average === 'number') {
        ratingValueEl.textContent = b.average.toFixed(1);
      }
      if (ratingCountEl && typeof b.count === 'number') {
        ratingCountEl.textContent = b.count.toLocaleString() + ' reviews';
      }
    };

    var cachedBottomline = null;
    try { cachedBottomline = JSON.parse(sessionStorage.getItem(looxCacheKey)); } catch (e) {}

    if (cachedBottomline) {
      applyBottomline(cachedBottomline);
    } else {
      fetch('https://loox.io/widget/' + encodeURIComponent(looxId) + '/reviews.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.bottomline) return;
          applyBottomline(d.bottomline);
          try { sessionStorage.setItem(looxCacheKey, JSON.stringify(d.bottomline)); } catch (e) {}
        })
        .catch(function () { /* keep the server-rendered numbers */ });
    }
  }

  /* ------------------------------------------------------------------------
     Gallery

     The scroller's position is the single source of truth for which slide is
     showing, so swiping and tapping a thumb can't disagree. Thumbs just scroll
     the track; the scroll handler updates everything else.
     ------------------------------------------------------------------------ */
  var galleryWrap = root.querySelector('[data-fb-gallery]');
  var slides = galleryWrap ? galleryWrap.querySelectorAll('[data-fb-slide]') : [];
  var thumbs = root.querySelectorAll('[data-fb-thumb]');

  // Videos play only while their slide is visible. Muted and playsinline are
  // forced here rather than trusted to the markup: browsers block autoplay on
  // anything with sound, and without playsinline iOS takes the video fullscreen.
  var syncSlideVideos = function () {
    slides.forEach(function (slide) {
      var player = slide.querySelector('video');
      if (!player) return;
      player.muted = true;
      player.playsInline = true;
      if (slide.classList.contains('is-active')) {
        var started = player.play();
        if (started && started.catch) started.catch(function () {});
      } else if (!player.paused) {
        player.pause();
      }
    });
  };

  var activeIndex = 0;

  var markActive = function (index) {
    activeIndex = index;
    slides.forEach(function (slide) {
      slide.classList.toggle('is-active', slide.getAttribute('data-fb-slide') === String(index));
    });
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-fb-thumb') === String(index));
    });
    // Collapsed row: a photo past the visible ones lights up the "+N" tile.
    if (moreThumb) moreThumb.classList.toggle('is-active', index >= thumbsVisible);
    syncSlideVideos();
  };

  /* "+N" thumbnail: with more photos than "Thumbnails shown before + more",
     the first ones show as usual, the next one gets a grey shade with +N
     (photos left), and the rest are hidden. Tapping it shows them all and
     opens that photo. The main gallery can always be swiped through every
     photo regardless. */
  var thumbsWrap = root.querySelector('[data-fb-thumbs-visible]');
  var thumbsVisible = thumbsWrap ? parseInt(thumbsWrap.getAttribute('data-fb-thumbs-visible'), 10) || 0 : 0;
  var moreThumb = null;
  var moreShade = null;
  var moreLabel = '';
  if (thumbsVisible > 0 && thumbs.length > thumbsVisible + 1) {
    moreThumb = thumbs[thumbsVisible];
    moreLabel = moreThumb.getAttribute('aria-label') || '';
    moreShade = document.createElement('span');
    moreShade.className = 'fb-thumb-more';
    moreShade.setAttribute('aria-hidden', 'true');
    moreShade.textContent = '+' + (thumbs.length - thumbsVisible);
    moreThumb.appendChild(moreShade);
    moreThumb.classList.add('fb-thumb--more');
    moreThumb.setAttribute('aria-label', 'Show all ' + thumbs.length + ' photos');
    moreThumb.setAttribute('aria-expanded', 'false');
    thumbsWrap.classList.add('is-collapsed');
    Array.prototype.forEach.call(thumbs, function (t, i) { if (i > thumbsVisible) t.hidden = true; });
    moreThumb.addEventListener('click', function () {
      if (!moreThumb) return;
      Array.prototype.forEach.call(thumbs, function (t) { t.hidden = false; });
      moreShade.remove();
      moreThumb.classList.remove('fb-thumb--more');
      moreThumb.setAttribute('aria-label', moreLabel);
      moreThumb.removeAttribute('aria-expanded');
      thumbsWrap.classList.remove('is-collapsed');
      moreThumb = null;
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = parseInt(thumb.getAttribute('data-fb-thumb'), 10);
      if (isNaN(index) || !galleryWrap) return;
      galleryWrap.scrollTo({ left: galleryWrap.clientWidth * index, behavior: 'smooth' });
      markActive(index);
    });
  });

  if (galleryWrap) {
    var scrollFrame;
    galleryWrap.addEventListener('scroll', function () {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(function () {
        if (!galleryWrap.clientWidth) return;
        var index = Math.round(galleryWrap.scrollLeft / galleryWrap.clientWidth);
        if (index !== activeIndex) markActive(index);
      });
    }, { passive: true });
  }

  // Also pauses any video the autoplay attribute started off-screen.
  markActive(0);
  // A ?variant= link to e.g. a specific neon colour opens on that colour's photo.
  showVariantMedia(currentVariant(), true);

  // A lazy image inside an off-screen slide won't fetch until it's revealed,
  // which would mean a blank beat on click. Flipping them to eager during idle
  // time pulls them in ahead of the click while still letting first paint
  // finish. Videos keep preload="metadata" so this never pulls down footage.
  var preloadGallery = function () {
    if (!galleryWrap) return;
    galleryWrap.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(preloadGallery, { timeout: 2000 });
  } else {
    setTimeout(preloadGallery, 1000);
  }
})();
